import React from 'react';
import {withSize} from 'react-sizeme';
import ParambreContainer from '../containers/ParambreContainer';

const App = () => (
  <div>
    <ParambreContainer />
  </div>
);

export default App;
